import CopyRight from "./common/CopyRight";
import libriLogo from "./assets/libri_white_logo.png";
import Header from "./common/Header";
import MainContainer from "./components/words/MainContainer";
import InstructionsButton from "./components/ai/InstructionsButton";

function App() {
  return (
    <div className="min-h-screen w-full bg-[#07162f] flex flex-col">
      {/* header */}
      <div className="shrink-0 px-3 py-3 md:px-0 md:py-4">
        <div className="flex justify-center">
          <Header topic="Word Cloud Generator" logoSrc={libriLogo} />
        </div>
      </div>

      {/* content */}
      <div className="flex-1 min-h-0 w-full flex justify-center px-3 pb-3 md:px-0 md:pb-0">
        <div className="w-[92vw] md:w-[95vw] flex flex-col min-h-0">
          <MainContainer />
        </div>
      </div>

      {/* footer */}
      <div className="shrink-0 px-3 py-2 md:px-0 md:py-4">
        <div className="flex justify-center">
          <CopyRight />
          <InstructionsButton />
        </div>
      </div>
    </div>
  );
}



export default App;